// extracted by mini-css-extract-plugin
export default {"main":"styles_main__gmE9U","presets-list":"styles_presets-list__Zjom-"};